import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";

const WS_BASE = `${process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws")}/api/ws`;

export function useRoomSocket(path) {
  const [state, setState] = useState(null);
  const [connected, setConnected] = useState(false);
  const [fatal, setFatal] = useState(null);
  const [deadline, setDeadline] = useState(0);
  const wsRef = useRef(null);

  useEffect(() => {
    if (!path) return undefined;
    let stop = false;
    let retry = 0;
    let timer;
    const connect = () => {
      const ws = new WebSocket(`${WS_BASE}${path}`);
      wsRef.current = ws;
      ws.onopen = () => { retry = 0; setConnected(true); };
      ws.onmessage = (e) => {
        const m = JSON.parse(e.data);
        if (m.type === "state") { setState(m.data); setDeadline(Date.now() + m.data.remaining_ms); }
        else if (m.type === "tick") setDeadline(Date.now() + m.remaining_ms);
        else if (m.type === "kicked") { stop = true; setFatal("kicked"); }
        else if (m.type === "error") { stop = true; setFatal(m.code); }
        else if (m.type === "notice") (m.level === "error" ? toast.error : toast.info)(m.message);
      };
      ws.onclose = () => {
        setConnected(false);
        if (!stop) timer = setTimeout(connect, Math.min(5000, 500 * 2 ** retry++));
      };
    };
    connect();
    const onVisible = () => {
      if (document.visibilityState === "visible" && wsRef.current?.readyState === WebSocket.CLOSED && !stop) {
        clearTimeout(timer);
        connect();
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      stop = true;
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", onVisible);
      wsRef.current?.close();
    };
  }, [path]);

  const send = useCallback((msg) => {
    const ws = wsRef.current;
    if (ws?.readyState === WebSocket.OPEN) ws.send(JSON.stringify(msg));
    else toast.error("Bağlantı yok, yeniden bağlanılıyor…");
  }, []);

  return { state, connected, fatal, send, deadline };
}

export function useRemaining(state, deadline) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(t);
  }, []);
  if (!state || (state.phase !== "question" && !(state.phase === "activity" && state.total_ms > 0))) return 0;
  if (state.paused) return state.remaining_ms;
  return Math.max(0, deadline - now);
}
